import "../styles/layout/Footer.scss";

function Footer(props) {
  return (
    <>
      <footer className="footer left">
        <div className="footer-info">
          <p className="footer_text ">
            &copy; designed & developed by cecilia periquet
            <span className="footer_heart"> ❤︎ </span>
            2023
          </p>
        </div>
      </footer>
    </>
  );
}

export default Footer;
